import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBillingApi, downloadInvoiceApi } from "helpers/ApiManager";
import { ApiResponse } from "types/ApiResponse";
import { BillingInvoicesPayload } from "types/biling.api";

export const getBillings = createAsyncThunk<
  ApiResponse<BillingInvoicesPayload>, // return type
  { starting_after?: string | null }, // argument type
  { rejectValue: string } // rejected type
>("invoices/getBilling", async (params, { rejectWithValue }) => {
  try {
    const response = await getBillingApi(params);
    console.log(params, "getBillingApi", response);
    return response;
  } catch (err: any) {
    console.log(err);
    return rejectWithValue(err?.message || "Failed to fetch");
  }
});

export const downloadInvoice = createAsyncThunk<
  Blob,
  { invoiceUrl: string },
  { rejectValue: string }
>("billing/downloadInvoice", async (params, { rejectWithValue }) => {
  try {
    const blob = await downloadInvoiceApi({
      pageUrl: params.invoiceUrl,
    });

    return blob;
  } catch (err: any) {
    return rejectWithValue(err?.message || "Failed to download invoice");
  }
});
